import { render, staticRenderFns } from "./RiwayatTertahan.vue?vue&type=template&id=5cec264d&scoped=true"
import script from "./RiwayatTertahan.vue?vue&type=script&lang=js"
export * from "./RiwayatTertahan.vue?vue&type=script&lang=js"
import style0 from "./RiwayatTertahan.vue?vue&type=style&index=0&id=5cec264d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cec264d",
  null
  
)

export default component.exports